import React, { useEffect, useState } from "react"
import { ClienteCard } from '../clientCard'
import { formatCPFCNPJ } from "../../../../utils/formatCPFCNPJ"
import { Loader } from "../../../generics/loader"
import { apiWhatsApp } from "../../../../services/api"
import { useIsFetching, useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { useAuth } from "../../../../context/AuthContext"
import { useModal } from "../../../../hooks/ModalContext"
import { format, subDays } from "date-fns"

interface FilaEsperaProps {

}

export const FilaEspera = ({ }: FilaEsperaProps) => {
  const queryClient = useQueryClient()
  const [user, setUser] = useState<any>()
  const { cookies, decodedToken } = useAuth()
  const { setModal } = useModal()



  function decoded() {
    if (cookies?.token) {
      const userDecoded = decodedToken()
      setUser(userDecoded)
    }
  }
  useEffect(() => {
    decoded()
  }, [cookies?.token])


  const { data, refetch, isSuccess, isRefetching } = useQuery({
    queryKey: ['transbordo-espera'], queryFn: async () => {
      const { data } = await apiWhatsApp.get(`/queue/chats/${cookies?.whatsapp?.queueId
        }`, { headers: { token: cookies?.whatsapp?.token } })
      return data
    },
    enabled: true,
    refetchInterval: 35000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
  },)

  const isFetching = useIsFetching({ queryKey: ['transbordo-espera'] })

  const isFetchingAtendimento = useIsFetching({ queryKey: ['transbordo-atendimento'] })


  const mutationTirarDaEspera = useMutation({
    mutationFn: (id_queue: string) => {
      return apiWhatsApp.post(`/queue/dequeue/${cookies?.whatsapp?.queueId
        }`, {}, { headers: { token: cookies?.whatsapp?.token } })
    },
    onError: () => setModal('Limite de 10 atendimento!', 'Erro', false, true)


  })


  async function mutateFilaEspera(id_queue: string) {
    await mutationTirarDaEspera.mutateAsync(id_queue)
    queryClient.refetchQueries({ queryKey: ['transbordo-atendimento'] })
    refetch()
  }

  function mostrarFila() {
    return (isSuccess && data?.length > 0) && data.slice(0, 30).map((queue: any) => {
      if (!queue.chat.attendanceStartedAt) {
        return (
          <button className=" w-full text-left cursor-pointer" key={queue._id} onDoubleClick={() => mutateFilaEspera(queue._id)} disabled={isRefetching}>
            <ClienteCard
              nome={queue.chat.name}
              hora_fila={queue.createdAt}
              text={
                "Transbordo"
              }
            />
          </button>
        )
      }
    })

  }


  return (
    <div className="mb-2 overflow-y-auto pr-1 " >
      <div className="">
        {(isFetching || isFetchingAtendimento || !isSuccess) && (<div className=" flex justify-center items-center  min-h-[1.5rem]  ">
          {isRefetching && <p className="text-primary text-xs font-bold mr-3">Carregando</p>}
          <Loader />
        </div>)}
        {mostrarFila()}
      </div>
    </div>
  )
}
